<script setup lang="ts">
import '@vueform/multiselect/themes/default.css'
import Multiselect from '@vueform/multiselect'
import BannersCategory from '@/assets/banner.svg?component'

const runtimeConfig = useRuntimeConfig()
const { path } = useRoute()
const store = useIndexStore()
const { bannersCategory} = storeToRefs(store)

const car = ref(null)
const track = ref(null)
const properties = ref([])
const loading = ref(false)
const submitting = ref(false)
const setSelected  = async () => {
  track.value = null
  properties.value = []
  if (car.value) {
    loading.value = true
    const response = await $fetch(`/store-api/product-listing/${car.value}`, {
      method: 'POST',
      body: {
        'manufacturer-filter': false,
        filter: [
          {
            type: 'not',
            queries: [
              {
                field: 'product.seo_url',
                type: 'equals',
                value: 'null'
              }
            ]
          }
        ],
        associations: {
          productReviews: {}
        },
        includes: {
          product_listing: ['aggregations']
        }
      },
      query: {
        url: path
      }
    })

    if (response && response.aggregations) {
        const { aggregations } = response
        properties.value = aggregations?.properties?.entities?.find(el => el.id === runtimeConfig.public.bannerProperties)?.options.map(({ id, name }: { id: string, name: string }) => ({ id, name: tor(name) }))
        loading.value = false
    } else {
        properties.value = []
    }
  }
}
const onSubmit = async () => {
  let url = '/k/jazda'
  if (car.value) {
    const carUrl = bannersCategory.value.find(el => el.id === car.value).extensions.categoryUrlData
    url = `/${carUrl.urlPrefix}/${carUrl.url}`
    if (track.value) {
      url += `?properties=${track.value}`
    }
  }
  await navigateTo(url)
  submitting.value = true
}
</script>

<template>
  <div class="bg-[#F8F9FA] relative p-[25px]">
    <div class="w-full h-full absolute top-0 left-0 overflow-hidden">
      <BannersCategory class="w-full h-full absolute top-0 left-0" />
    </div>
    <div class="relative">
      <div class="font-bold mb-[15px]">
        Jazda supersamochodami
      </div>

      <div class="flex flex-col md:flex-row gap-[15px]">
        <Multiselect
          v-model="car"
          :options="bannersCategory"
          label="name"
          valueProp="id"
          placeholder="Wybierz samochód"
          class="multiselect-primary w-full bg-white text-12 font-medium"
          @select="setSelected"
        />

        <Multiselect
          v-model="track"
          :options="properties"
          label="name"
          valueProp="id"
          placeholder="Wybierz tor"
          :disabled="!properties?.length"
          :loading="loading"
          class="multiselect-primary w-full bg-white text-12 font-medium"
        />

        <button class="flex justify-center items-center gap-[5px] bg-primary h-[40px] text-12 text-white whitespace-nowrap rounded-[5px] px-[15px]" @click="onSubmit">
          Sprawdź ofertę
          <LoadingIndicator v-if="submitting" class="h-[16px] w-[16px] text-white" />
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.multiselect-primary {
  --ms-font-size: 12px;
  --ms-ring-width: 0;
  --ms-option-font-size: 12px;
  --ms-option-bg-selected: theme(colors.primary.DEFAULT);
  --ms-option-bg-selected-pointed: theme(colors.primary.DEFAULT);
}
</style>
